import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { useCurrentChainInfo } from "@looksrare/utils";
import { getCanonicalAndLanguageAlternates } from "config/seo";
import Page from "components/Layout/Page";
import { SubscribeEmailView } from "views/subscribe/SubscribeEmailView";

const SubscribeEmailPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = useCurrentChainInfo();

  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    "/subscribe",
    router,
    currentChainInfo.appUrl
  );
  const title = "Join the LooksRare Mailing List";
  const description =
    "Stay in the loop. Sign up to our email list for monthly product updates, new feature alerts, and free alpha. No spam, ever.";
  return (
    <Page>
      <NextSeo
        title={t("{{pageTitle}} | LooksRare", { pageTitle: title })}
        openGraph={{
          title: t("{{pageTitle}} | LooksRare", { pageTitle: title }),
          url: canonical,
          description: description,
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <SubscribeEmailView />
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
      locale,
    },
  };
};

export default SubscribeEmailPage;
